import { Product, ProductFilter, ProductSort } from 'types/schema';

export interface IHomePreloadTopShowcase {
  sectionKey: string;
  data: Product[];
  basePage: number;
  totalPages: number;
  /** Tổng số sản phẩm khớp query — client suy ra totalPages/fullPages từ đây. */
  totalResults?: number;
  /** Số trang đầy, tức miền xoay của basePage. Xem calcFullPages (carouselRules.ts). */
  fullPages?: number;
  sort: ProductSort[];
  filter: ProductFilter;
  sectionId?: string | null;
}

export interface IHomePreload {
  region: string;
  lang: string;
  seed: number;
  topShowcase?: IHomePreloadTopShowcase;
}

let consumed = false;

export function readRawHomePreload(): IHomePreload | null {
  try {
    return ((window as any).__PRELOADED_STATE__?.homePage as IHomePreload) || null;
  } catch {
    return null;
  }
}

export function isHomePreloadUsable(
  preload: IHomePreload | null | undefined,
  region: string,
  lang: string,
  seed: number,
  sectionKey?: string | null,
): boolean {
  if (!preload?.topShowcase?.data?.length) {
    return false;
  }

  if (preload.region !== region || preload.lang !== lang) {
    return false;
  }

  if (preload.seed !== seed) {
    return false;
  }

  if (sectionKey && preload.topShowcase.sectionKey !== sectionKey) {
    return false;
  }

  return true;
}

export function readHomePreload(region: string, lang: string, sectionKey: string, seed: number): IHomePreload | null {
  if (consumed) {
    return null;
  }

  const preload = readRawHomePreload();

  if (!isHomePreloadUsable(preload, region, lang, seed, sectionKey)) {
    return null;
  }

  consumed = true;

  return preload;
}

export function isHomePreloadConsumed(): boolean {
  return consumed;
}

export function resetHomePreloadForTest(): void {
  consumed = false;
}

export function mergePreservingOrder(current: Product[], fresh: Product[]): Product[] {
  if (!fresh?.length) {
    return current;
  }

  const freshById = new Map<string, Product>();

  fresh.forEach((p) => {
    if (p?.id) {
      freshById.set(p.id, p);
    }
  });

  const merged = current.map((p) => {
    const hydrated = p?.id ? freshById.get(p.id) : undefined;

    return hydrated ? { ...p, ...hydrated } : p;
  });

  const seen = new Set(merged.map((p) => p?.id));

  fresh.forEach((p) => {
    if (p?.id && !seen.has(p.id)) {
      merged.push(p);
    }
  });

  return merged;
}
